import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitokolhapurcab() {



    const cardData = {

keyword: "Navi Mumbai to Kolhapur Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai to Kolhapur Cab services for family trips, pilgrimage travel, weekend getaways, corporate travel, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Navi Mumbai, and safe highway driving via Pune–Kolhapur route, we ensure a smooth, comfortable, and hassle-free travel experience to Kolhapur.",

topPlaces: [
    {
        title: "Mahalaxmi Temple",
        description:
            "Mahalaxmi Temple is the most famous attraction in Kolhapur dedicated to Goddess Lakshmi and is one of the Shakti Peeths visited by devotees from across India."
    },
    {
        title: "Rankala Lake",
        description:
            "Rankala Lake is a scenic and peaceful lake in Kolhapur offering boating, sunset views, and relaxing evening walks for families and tourists."
    },
    {
        title: "Panhala Fort",
        description:
            "Panhala Fort is a historic Maratha fort known for its massive structure, battle history, and panoramic views of the Sahyadri mountains."
    },
    {
        title: "Jyotiba Temple",
        description:
            "Jyotiba Temple is a famous hill temple near Kolhapur dedicated to Lord Jyotiba and is especially crowded during annual festivals."
    },
    {
        title: "New Palace Museum",
        description:
            "New Palace Museum showcases royal artifacts, weapons, costumes, and history of the Kolhapur royal family in a grand architectural building."
    },
    {
        title: "Shivaji University Area",
        description:
            "The Shivaji University region is a major educational and urban hub in Kolhapur with greenery, academic institutions, and local activity."
    },
    {
        title: "Gaganbawda Ghat",
        description:
            "Gaganbawda Ghat is a scenic mountain pass near Kolhapur known for lush greenery, waterfalls during monsoon, and breathtaking valley views."
    },
    {
        title: "Radhanagari Wildlife Sanctuary",
        description:
            "Radhanagari Wildlife Sanctuary is a rich biodiversity zone known for forests, wildlife species, and eco-tourism experiences near Kolhapur."
    },
    {
        title: "Kaneri Math",
        description:
            "Kaneri Math is a spiritual and cultural site known for its ancient monastery, idols, and peaceful surroundings for visitors."
    },
    {
        title: "Kolhapur City Market",
        description:
            "Kolhapur city markets are famous for Kolhapuri chappals, jewelry, spices, and traditional Maharashtrian shopping experiences."
    }
],



services: [
{
name: "Mumbai to Kolhapur Cab",
description: "Mumbai to Kolhapur Cab service by 1Touch Cabs offers safe, comfortable, and reliable intercity transportation for families, business travellers, tourists, and group travelers. We provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller with professional chauffeurs experienced in long-distance highway travel. Whether it is a one-way trip, round trip, or urgent travel requirement, we ensure punctual pickups, smooth driving, luggage assistance, and a stress-free journey. With 24x7 availability, transparent pricing, and easy online booking, we make Mumbai to Kolhapur travel convenient, affordable, and dependable."
},
{
name: "Mumbai Airport to Kolhapur Cab",
description: "Mumbai Airport to Kolhapur Cab service provides direct and comfortable long-distance transfers from Mumbai International Airport to Kolhapur. 1Touch Cabs ensures timely airport pickups with flight tracking, professional chauffeurs, and clean air-conditioned vehicles for a smooth onward journey. Our service is ideal for arriving passengers, corporate travellers, and families who need safe and hassle-free travel after landing. We offer flexible vehicle options, transparent fares, and reliable support to make airport-to-city travel seamless and efficient."
},
{
name: "Mumbai Kolhapur Cab Service",
description: "Mumbai Kolhapur Cab Service by 1Touch Cabs delivers dependable intercity travel solutions with a strong focus on safety, comfort, and punctuality. We operate a wide fleet of vehicles suitable for solo travellers, families, and groups, ensuring every journey is comfortable and well-managed. Our experienced drivers are trained for long highway routes, providing smooth rides with proper breaks and assistance. With affordable pricing, 24x7 booking support, and professional service, we ensure a reliable travel experience between Mumbai and Kolhapur."
},
{
name: "Mumbai to Kolhapur Car Rental",
description: "Mumbai to Kolhapur Car Rental service offers flexible and affordable transportation options for both one-way and round-trip journeys. 1Touch Cabs provides a range of vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and premium options for comfortable long-distance travel. Our service includes professional chauffeurs, clean vehicles, transparent pricing, and customizable travel plans. Whether for business trips, family travel, or tourism, we ensure a smooth and comfortable journey experience."
},
{
name: "Navi Mumbai to Kolhapur Cab",
description: "Navi Mumbai to Kolhapur Cab service provides reliable intercity transportation for passengers travelling from Navi Mumbai regions like Vashi, Nerul, Belapur, Kharghar, and Panvel to Kolhapur. 1Touch Cabs offers comfortable vehicles, experienced drivers, and safe highway travel with flexible pickup options. We ensure punctual service, affordable fares, and smooth long-distance journeys suitable for families, corporate travellers, and tourists."
},
{
name: "Navi Mumbai to Kolhapur Taxi",
description: "Navi Mumbai to Kolhapur Taxi service delivers safe and convenient long-distance travel solutions with professional chauffeurs and well-maintained vehicles. 1Touch Cabs provides Sedan, SUV, Innova, and premium cab options for individuals and groups. Our focus is on comfort, punctuality, and affordability, ensuring a stress-free journey from Navi Mumbai to Kolhapur with 24x7 booking support and transparent pricing."
},
{
name: "Navi Mumbai to Kolhapur Cab Service",
description: "Navi Mumbai to Kolhapur Cab Service offers dependable transportation for business trips, family travel, tourism, and urgent intercity journeys. 1Touch Cabs ensures comfortable vehicles, trained chauffeurs, and smooth highway travel with complete safety. We provide flexible booking options, competitive pricing, and reliable customer support to make long-distance travel efficient and convenient."
},
{
name: "Taxi from Navi Mumbai to Kolhapur",
description: "Taxi from Navi Mumbai to Kolhapur service provides comfortable and direct transportation with experienced drivers and well-maintained vehicles. 1Touch Cabs ensures timely pickups, smooth highway driving, and assistance throughout the journey. Whether travelling for work, family visits, or tourism, passengers benefit from safe travel, transparent fares, and dependable service."
},
{
name: "Cab from Navi Mumbai to Kolhapur",
description: "Cab from Navi Mumbai to Kolhapur service offers reliable intercity travel solutions with a fleet of Sedan, SUV, Innova, and premium vehicles. 1Touch Cabs focuses on comfort, safety, and affordability, ensuring a smooth journey experience. Our professional chauffeurs handle long-distance routes efficiently, providing passengers with stress-free and enjoyable travel."
},
{
name: "Book Cab Navi Mumbai to Kolhapur",
description: "Book Cab Navi Mumbai to Kolhapur service allows customers to reserve long-distance taxis quickly and easily through a simple booking process. 1Touch Cabs offers instant confirmations, multiple vehicle options, transparent pricing, and 24x7 customer support. Whether for planned travel or urgent trips, we ensure reliable and comfortable transportation."
},
{
name: "Online Cab Booking Navi Mumbai to Kolhapur",
description: "Online Cab Booking Navi Mumbai to Kolhapur service provides a fast and convenient way to reserve intercity transportation. 1Touch Cabs offers easy booking, flexible scheduling, affordable fares, and professional chauffeur support. Passengers can choose from multiple vehicle types and enjoy a seamless booking experience with reliable travel assurance."
},
{
name: "Best Cab Navi Mumbai to Kolhapur",
description: "Best Cab Navi Mumbai to Kolhapur service by 1Touch Cabs ensures premium-quality intercity travel with professional chauffeurs, clean vehicles, and reliable service standards. We focus on passenger comfort, safety, and punctuality while offering competitive pricing and excellent support. Ideal for families, business travellers, and tourists seeking dependable travel."
},
{
name: "Cheapest Cab Navi Mumbai to Kolhapur",
description: "Cheapest Cab Navi Mumbai to Kolhapur service offers budget-friendly travel without compromising comfort or safety. 1Touch Cabs provides affordable fares, well-maintained vehicles, and experienced drivers for smooth highway journeys. We ensure transparent pricing and reliable service, making intercity travel economical and stress-free."
},
{
name: "One Way Cab Navi Mumbai to Kolhapur",
description: "One Way Cab Navi Mumbai to Kolhapur service is designed for passengers needing direct drop transportation without return charges. 1Touch Cabs offers cost-effective one-way pricing, comfortable vehicles, and professional chauffeurs for long-distance travel. This service is ideal for relocation, business travel, and single-trip journeys."
},
{
name: "Round Trip Cab Navi Mumbai to Kolhapur",
description: "Round Trip Cab Navi Mumbai to Kolhapur service provides flexible return travel options for families, tourists, and corporate travellers. 1Touch Cabs offers customized travel plans, waiting options, and comfortable vehicles for complete round-trip journeys. We ensure convenience, safety, and affordability throughout the trip."
},
{
name: "Outstation Cab Navi Mumbai to Kolhapur",
description: "Outstation Cab Navi Mumbai to Kolhapur service offers reliable long-distance travel solutions for tourism, business, and family trips. 1Touch Cabs provides a wide range of vehicles, professional drivers, and safe highway travel. With transparent pricing and 24x7 support, we ensure a smooth outstation travel experience."
},
{
name: "Innova Cab Navi Mumbai to Kolhapur",
description: "Innova Cab Navi Mumbai to Kolhapur service provides spacious and comfortable transportation for families and group travelers. 1Touch Cabs offers well-maintained Innova vehicles with experienced chauffeurs for long-distance journeys. We ensure comfort, safety, and smooth travel across highways."
},
{
name: "Innova Crysta Cab Navi Mumbai to Kolhapur",
description: "Innova Crysta Cab Navi Mumbai to Kolhapur service delivers premium long-distance travel with luxury seating, extra comfort, and professional chauffeurs. 1Touch Cabs ensures a smooth and relaxing journey ideal for families, corporate clients, and VIP travellers. We offer safe and comfortable highway transportation."
},
{
name: "Ertiga Cab Navi Mumbai to Kolhapur",
description: "Ertiga Cab Navi Mumbai to Kolhapur service offers affordable and comfortable travel for small families and groups. 1Touch Cabs provides clean vehicles, professional drivers, and smooth highway journeys. This service is ideal for budget-friendly intercity transportation."
},
{
name: "Swift Dzire Cab Navi Mumbai to Kolhapur",
description: "Swift Dzire Cab Navi Mumbai to Kolhapur service provides economical sedan travel for individuals and small families. 1Touch Cabs ensures comfortable seating, safe driving, and affordable pricing for long-distance journeys. Perfect for budget intercity travel."
},
{
name: "Kia Carens Cab Navi Mumbai to Kolhapur",
description: "Kia Carens Cab Navi Mumbai to Kolhapur service offers modern, spacious, and comfortable transportation for families and group travel. 1Touch Cabs provides well-maintained Kia Carens vehicles with experienced chauffeurs for a smooth and safe journey."
},
{
name: "Sedan Cab Navi Mumbai to Kolhapur",
description: "Sedan Cab Navi Mumbai to Kolhapur service provides budget-friendly and comfortable transportation for individuals and couples. 1Touch Cabs offers clean air-conditioned sedans with professional drivers for safe and reliable long-distance travel."
},
{
name: "SUV Cab Navi Mumbai to Kolhapur",
description: "SUV Cab Navi Mumbai to Kolhapur service offers powerful and spacious vehicles for families and group travelers. 1Touch Cabs ensures comfortable seating, safe highway travel, and professional chauffeur service for a smooth journey experience."
}
],

tableData: [
["Mumbai to Kolhapur Cab","Mumbai Airport to Kolhapur Cab"],
["Mumbai Kolhapur Cab Service","Mumbai to Kolhapur Car Rental"],
["Navi Mumbai to Kolhapur Cab","Navi Mumbai to Kolhapur Taxi"],
["Navi Mumbai to Kolhapur Cab Service","Taxi from Navi Mumbai to Kolhapur"],
["Cab from Navi Mumbai to Kolhapur","Book Cab Navi Mumbai to Kolhapur"],
["Online Cab Booking Navi Mumbai to Kolhapur","Best Cab Navi Mumbai to Kolhapur"],
["Cheapest Cab Navi Mumbai to Kolhapur","One Way Cab Navi Mumbai to Kolhapur"],
["Round Trip Cab Navi Mumbai to Kolhapur","Outstation Cab Navi Mumbai to Kolhapur"],
["Innova Cab Navi Mumbai to Kolhapur","Innova Crysta Cab Navi Mumbai to Kolhapur"],
["Ertiga Cab Navi Mumbai to Kolhapur","Swift Dzire Cab Navi Mumbai to Kolhapur"],
["Kia Carens Cab Navi Mumbai to Kolhapur","Sedan Cab Navi Mumbai to Kolhapur"],
["SUV Cab Navi Mumbai to Kolhapur","Navi Mumbai Cab Service"]
],













whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai to Kolhapur Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai to Kolhapur Cab services for families, business travelers, pilgrims, tourists, and corporate professionals seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Convenient Travel Between Navi Mumbai and Kolhapur",
        WhyChoosedescription: "Our cab service offers hassle-free connectivity for family visits, business meetings, educational travel, temple visits, and leisure trips between Navi Mumbai and Kolhapur."
    },
    {
        WhyChooseheading: "Perfect for Tourism and Pilgrimage Travel",
        WhyChoosedescription: "Kolhapur is famous for the Shri Mahalaxmi Temple, Panhala Fort, Rankala Lake, and rich cultural heritage, attracting thousands of visitors throughout the year."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, same-day return, round trip, or customized travel package, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Navi Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, CBD Belapur, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on long-distance Maharashtra routes and ensure safe, smooth, and comfortable transportation."
    },
    {
        WhyChooseheading: "Ideal for Families, Corporate Travelers, and Groups",
        WhyChoosedescription: "From individual travelers and families to pilgrimage groups and corporate teams, we provide suitable vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Navi Mumbai to Kolhapur Cabs?",
        answer: "Kolhapur attracts visitors for Mahalaxmi Temple Darshan, tourism, business meetings, family functions, educational visits, and cultural experiences."
    },
    {
        question: "Can I book a one-way cab from Navi Mumbai to Kolhapur?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Navi Mumbai to Kolhapur travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide Mahalaxmi Temple Darshan packages?",
        answer: "Yes, customers can book customized Kolhapur pilgrimage packages including Mahalaxmi Temple and nearby attractions."
    },
    {
        question: "Can families travel comfortably to Kolhapur?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for families, senior citizens, children, and long-distance travelers."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, pilgrimage tours, corporate teams, and tourist groups."
    },
    {
        question: "Can sightseeing places be included during the trip?",
        answer: "Yes, customers can visit Mahalaxmi Temple, Panhala Fort, Rankala Lake, Jyotiba Temple, New Palace Museum, and other attractions."
    },
    {
        question: "Can pickup be arranged from any Navi Mumbai location?",
        answer: "Yes, pickup services are available from homes, hotels, offices, railway stations, and all major areas of Navi Mumbai."
    },
    {
        question: "Is advance booking recommended for Navi Mumbai to Kolhapur travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle, especially during weekends, holidays, and festival seasons."
    },
    {
        question: "How can I book a Navi Mumbai to Kolhapur Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Pravin Patil",
        feedback:
            "We booked a cab for Mahalaxmi Temple Darshan and were very satisfied with the service. The vehicle was comfortable, the driver was professional, and the journey was smooth throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Kulkarni",
        feedback:
            "Our family trip to Kolhapur was perfectly organized. The cab was clean, spacious, and the driver was courteous, making our travel experience enjoyable and stress-free.",
        rating: 5
    }
];

























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai to Kolhapur Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-to-kolhapur-cab.jpg",
"description": "Book Navi Mumbai to Kolhapur cab service for safe and comfortable long-distance travel. Mumbai Airport Cabs offers reliable outstation taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/navi-mumbai-to-kolhapur-cab"
}
};








    return (
        <div>

<Helmet>
  <title>Navi Mumbai to Kolhapur Cab | Outstation Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Navi Mumbai to Kolhapur cab for safe and comfortable outstation travel. Reliable taxi service with professional drivers, one-way and round-trip options, and 24x7 availability."
/>

<meta
 name="keywords"
 content="navi mumbai to kolhapur cab, mumbai to kolhapur cab, mumbai airport to kolhapur cab, mumbai kolhapur cab service, navi mumbai to kolhapur taxi, cab from navi mumbai to kolhapur, book cab navi mumbai to kolhapur, online cab booking navi mumbai to kolhapur, cheapest cab navi mumbai to kolhapur"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaitokolhapurcab;